export const hideNavigationPaneButton = "m2wLxc";
export const pinNavigationPaneButton = "lKuMN";
export default {hideNavigationPaneButton,pinNavigationPaneButton};